<df-monorepo-ticket-checkout-stripe 
  class="mt2" 
  [ticketOrder]="ticketOrder"
></df-monorepo-ticket-checkout-stripe>
